import fp from "lodash/fp";
import { uiConstants } from "./ui.constants";
import { getModals } from "./ui.reducer";

export const uiActions = {
	showNotification,
	showInfoNotification,
	showSuccessNotification,
	showErrorNotification,
	hideNotification,
	showSpinnerOverlay,
	hideSpinnerOverlay,
	showModal,
	hideModal,
	showSessionExpirationModal,
	hideSessionExpirationModal,
	showServerErrorModal,
	hideServerErrorModal,
	showNoConnectionModal,
	hideNoConnectionModal,
	setIsOnline,
};

function showNotification({ title, variant }) {
	return {
		type: uiConstants.OPEN_NOTIFICATION,
		title,
		variant,
	};
}

function showSuccessNotification({ title, delay = 3000 }) {
	return dispatch => {
		dispatch(showNotification({ title, variant: "success" }));
		setTimeout(() => dispatch(hideNotification()), delay);
	};
}

function showInfoNotification({ title, delay = 3000 }) {
	return dispatch => {
		dispatch(showNotification({ title, variant: "success" }));
		setTimeout(() => dispatch(hideNotification()), delay);
	};
}

function showErrorNotification({ title, delay = 3000 }) {
	return dispatch => {
		dispatch(showNotification({ title, variant: "failure" }));
		setTimeout(() => dispatch(hideNotification()), delay);
	};
}

function hideNotification() {
	return {
		type: uiConstants.CLOSE_NOTIFICATION,
	};
}

function showSpinnerOverlay() {
	return {
		type: uiConstants.SHOW_SPINNER_OVERLAY,
	};
}
function hideSpinnerOverlay() {
	return {
		type: uiConstants.HIDE_SPINNER_OVERLAY,
	};
}

export function showModal(modalType, modalState) {
	return {
		type: uiConstants.PUSH_MODAL,
		modal: {
			...modalState,
			show: true,
			modalType,
		},
	};
}

export function hideModal(modalType) {
	return {
		type: uiConstants.POP_MODAL,
		modalType,
	};
}

export function showModalEnsureSingleInstance(modalType, modalState) {
	return (dispatch, getState) => {
		const state = getState();
		const modals = getModals(state);
		const counter = fp.countBy({ modalType }, modals);

		if (!counter.true || counter.true === 0) {
			dispatch(showModal(modalType, modalState));
		}
	};
}

export function hideModalEnsureSingleInstance(modalType) {
	return (dispatch, getState) => {
		const state = getState();
		const modals = getModals(state);
		const counter = fp.countBy({ modalType }, modals);

		if (counter.true !== undefined && counter.true > 0) {
			dispatch(hideModal(modalType));
		}
	};
}

function showSessionExpirationModal() {
	return showModalEnsureSingleInstance("SESSION_EXPIRATION");
}

function hideSessionExpirationModal() {
	return hideModalEnsureSingleInstance("SESSION_EXPIRATION");
}

function showServerErrorModal() {
	return showModalEnsureSingleInstance("SERVER_ERROR");
}

function hideServerErrorModal() {
	return hideModalEnsureSingleInstance("SERVER_ERROR");
}

function showNoConnectionModal() {
	return showModalEnsureSingleInstance("NO_CONNECTION");
}

function hideNoConnectionModal() {
	return hideModalEnsureSingleInstance("NO_CONNECTION");
}

function setIsOnline(isOnline) {
	return {
		type: uiConstants.SET_IS_ONLINE,
		isOnline,
	};
}
